import classNames from "classnames"
import React, { useMemo } from "react"

import { trimText } from "@bounce/util"
import type { PNImageProps } from "@bounce/web-components"
import { ReviewMetaData, PNImage } from "@bounce/web-components"

import { useReviewUsername } from "../../../../hooks/useReviewUsername"
import type { Review } from "@/utils/reviews"

import DEFAULT_IMAGE from "@/assets/img/default_hero_2.png"

export type FeaturedReviewCardProps = {
  review: Review
  className?: string
  imageSrc?: PNImageProps["src"]
}

export const FeaturedReviewCard = ({ review, imageSrc, className }: FeaturedReviewCardProps) => {
  const name = useReviewUsername({ review })
  const metadata = useMemo(() => `BOUNCED: ${review.country ?? review.city.translatedName}`, [review])

  return (
    <div
      className={classNames(
        "flex flex-col-reverse justify-between overflow-hidden rounded-lg border-2 border-neutral-300 sm:flex-row",
        className,
      )}>
      <div className="h-[200px] w-full sm:w-1/3 md:h-auto">
        <PNImage
          src={imageSrc || DEFAULT_IMAGE}
          height={615}
          width={520}
          imgixParams={{ fit: "crop", w: 520, h: 615 }}
          loading="eager"
          priority
          className="h-[200px] w-full object-cover object-center md:h-auto"
          data-chromatic="ignore"
        />
      </div>
      <div className="w-full px-5 pb-8 pt-4 sm:w-2/3 md:px-8 md:pt-9 xl:px-12 xl:pb-12">
        <ReviewMetaData name={name} rating={review.rating} metaData={metadata} className="mb-6 md:mb-7 xl:mb-9" />
        <p className="paragraph1 !leading-[145%] text-black md:text-2xl xl:text-3xl">
          {trimText(review.feedback || "", 180)}
        </p>
      </div>
    </div>
  )
}
